
import icons from '../utils/icons';
const Button = ({ classAddDisable, content, handleFormData, emailValid, loading }) => {
    return content?.button.length > 0 && <div className='submitBtn' >

        <button onClick={handleFormData} className={`${!classAddDisable && 'disable'}`} disabled={!emailValid}>{content.button}</button>
        {loading && <div className='loader'> {icons.loader}</div>}
    </div>
}
export default Button;